import request from '@/utils/request'

const baseUrl = '/erp/purchase/report/purchase-inbound-detail'

export const pagePurchaseInboundDetailReport = params => request({
  url: baseUrl + '/page',
  method: 'get',
  params
})

export const listPurchaseInboundDetailSupplierOptions = () => request({
  url: baseUrl + '/supplier-options',
  method: 'get'
})

export const exportPurchaseInboundDetailReport = params => request({
  url: baseUrl + '/export',
  method: 'get',
  params,
  responseType: 'blob'
})
